import React from "react";
import Card from "./Card";

const ExchangeList = ({ exchanges }) => {
  return (
    <Card>
      <h3 className="text-xl font-bold text-[var(--text-primary)] mb-6">
        Connected Exchanges
      </h3>
      <div className="space-y-4">
        {exchanges.map((exchange, index) => (
          <div
            key={index}
            className="flex items-center justify-between p-4 card-gradient rounded-xl border border-primary/10 hover:border-primary/20 transition-all duration-200"
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 card-gradient rounded-full flex items-center justify-center">
                <span className="text-xl text-[var(--text-primary)] font-bold">
                  {exchange.name.charAt(0)}
                </span>
              </div>
              <div>
                <h4 className="text-[var(--text-primary)] font-semibold">
                  {exchange.name}
                </h4>
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <span
                className={`w-2 h-2 rounded-full ${
                  exchange.connected ? "bg-green-400" : "bg-red-400"
                }`}
              />
              <span
                className={`text-sm font-medium ${
                  exchange.connected ? "text-green-400" : "text-red-400"
                }`}
              >
                {exchange.connected ? "Connected" : "Disconnected"}
              </span>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default ExchangeList;
